import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { CalendarIcon, CrossmarkIcon } from 'assets/icons';
import { useFormikField } from 'common/components/form/useFormikField';
import { FieldLabel } from 'common/components/form/Wrapper/FieldLabel';
import { Error } from 'common/components/form/Wrapper/Wrapper.styled';
import { useScreenSizeDetection } from 'common/hooks';

import { IDateTimeField } from './IDateTimeField';
import { DatePickerStyled, DatePickerWrapper } from './index.styled';

export const DateTimeField = ({
  name,
  label,
  dateFormat,
  additionalStyle,
  removeRightIcon,
  hasErrorMargin,
  needConfirm,
  ...rest
}: IDateTimeField) => {
  const { value, setValue, hasError, error } = useFormikField(name);
  const { t } = useTranslation();
  const { isMobile } = useScreenSizeDetection();

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const { disableClearIcon, placeholder } = rest;

  const onChange = (date: any) => {
    setValue(date);
    if (rest.onChange) {
      rest.onChange(date);
    }
  };

  return (
    <DatePickerWrapper>
      {!!label && (
        <FieldLabel label={label} name={name} isRequired={rest.required} tooltip={rest.labelIcon} />
      )}
      <DatePickerStyled
        {...rest}
        open={isPopupOpen}
        additionalStyle={additionalStyle}
        placeholder={placeholder || t('Select...')}
        format={dateFormat || 'DD.MM.YYYY HH:mm'}
        name={name}
        value={!!value ? dayjs(value) : null}
        onChange={onChange}
        disabled={rest.disabled}
        suffixIcon={
          !removeRightIcon ? <CalendarIcon width={24} height={24} fill="#cacccf" /> : null
        }
        allowClear={{
          clearIcon: !disableClearIcon && <CrossmarkIcon width={24} height={24} fill="#cacccf" />,
        }}
        //status={hasError ? 'error' : undefined}
        $hasError={hasError}
        showTime
        needConfirm={needConfirm || false}
        inputReadOnly={isMobile}
        onClick={() => setIsPopupOpen(true)}
        onOpenChange={open => {
          if (!open) {
            setIsPopupOpen(false);
          }
        }}
        onCalendarChange={date => {
          if (!Array.isArray(date) && date) {
            if (date.hour() || date.minute()) {
              setIsPopupOpen(true);

              return;
            }

            if (date.date() && date.hour() && date.minute()) {
              setIsPopupOpen(false);
            }
          }
        }}
      />

      {hasError && (
        <Error margin={hasError ? (hasErrorMargin ? hasErrorMargin : '-1.25rem 0 1rem 0') : null}>
          {t(String(error))}
        </Error>
      )}
    </DatePickerWrapper>
  );
};
